import React, { useState, useEffect, useRef, useCallback, useReducer } from 'react';
import { useHistory } from 'react-router-dom';
import { usePlaces } from '../../hooks';

import {
    Toolbar,
    Paper,
    Button,
    Grid,
    Typography,
    Checkbox,
    TableContainer,
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
    TablePagination,
    FormControlLabel,
    useTheme,
    useMediaQuery,
} from '@material-ui/core';

import { grey, indigo } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';

import SaveIcon from '@material-ui/icons/Save';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import DeleteIcon from '@material-ui/icons/Delete';
import SearchIcon from '@material-ui/icons/Search';
import UploadIcon from '@mui/icons-material/Upload';
import VideocamIcon from '@mui/icons-material/Videocam';

import Webcam from 'react-webcam';
import { Formik } from 'formik';
import MaskedInput from 'react-text-mask';
import { loadPlayer } from 'rtsp-relay/browser';

import SideMenu from '../../components/SideMenu';
import Alert from '../../components/Alert';
import Input from '../../components/Input';
import Select from '../../components/Select';
import DatePicker from '../../components/DatePicker';
import TimePicker from '../../components/TimePicker';
import DaysPicker from '../../components/DaysPicker';
import Popup from '../../components/Popup';
import AccessPicker from '../../components/AccessPicker';
import CredentialsManager from '../../components/CredentialsManager';
import RedirectToUser from '../../components/RedirectToUser';
import Autocomplete from '../../components/Autocomplete.js';
import FullScreenDialog from '../../components/FullScreenDialog';
import IPWebcamPicker from '../../components/IPWebcamPicker';

import api from '../../services/api';
import date from '../../utils/date';
import config from '../../configs/config';

const validationInitialState = {
    start_time: new Date().setHours(0, 0, 0, 0),
    end_time: new Date().setHours(23, 59, 59, 0),
};

const handleValidationDate = (state, action) => {
    switch (action.type) {
        case 'change':
            return {
                ...state,
                [action.time]: action.value && action.value.format(),
            };
        case 'reset':
            return validationInitialState;
        default: return state;
    }
};

export default function SimplifiedRegistration() {
    const classes = useStyles();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const history = useHistory();

    const [openGoBack, setOpenGoBack] = useState(false);

    const accessRef = useRef(null);
    const credentialsRef = useRef()

    let initialValues = {
        name: '',
        birthday: null,
        sex: 'unknown',
        doc_type: '',
        doc_number: '',
        issuing_agency: '',
        email: '',
        phone: null,
        role: 'visitor',
        face_image: null,
        validation_date: date().format(),
        constant_visiting: false,
        visiting_location: null,
        notes: '',
        custom_inputs: [],
        only_allowed_by_related_access: false,
    };

    const [placesSearch, setPlacesSearch] = useState("");
    const [selectedPlace, setSelectedPlace] = useState({});
    const places = usePlaces({
        search: placesSearch,
    });
    const [cameraOpened, setCameraOpened] = useState(false);
    const [message, setMessage] = useState({
        open: false,
        variant: '',
        text: '',
    });

    const [validationDate, dispatchValidationDate] = useReducer(handleValidationDate, validationInitialState);
    const [days, setDays] = useState(null)

    const webcamRef = useRef(null);
    const daysRef = useRef(null);

    const [loadedImage, setLoadedImage] = useState(null);

    const takeWebcamSnapshot = async setFieldValue => {
        if (!selectedWebcam) return;

        try {
            const result = await api.get(`/device/take_snapshot/${selectedWebcam.id}`, {
                responseType: 'blob',
            });

            const dataUrl = URL.createObjectURL(result.data);

            const image = await fetch(dataUrl)
                .then(res => res.arrayBuffer())
                .then(buffer => new File([buffer], 'face_image.jpeg', {type: 'image/jpeg'}));

            setFieldValue('face_image', image);
            setSelectedWebcam(null);
            handleCloseRSTP();
        }
        catch (err) {
            console.log(err);
        }
    };

    const captureImage = useCallback(async setFieldValue => {
        const dataUrl = webcamRef.current.getScreenshot();

        if (dataUrl) {
            const mimeType = dataUrl.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/);

            const image = await fetch(dataUrl)
                .then(res => res.arrayBuffer())
                .then(buffer => new File([buffer], 'face_image.jpeg', { type: mimeType[0] }));

            setFieldValue('face_image', image);
        }
    }, [webcamRef]);

    const uploadImage = (e, setFieldValue) => {
        const reader = new FileReader()
        reader.onload = () => {
            if (reader.readyState === 2) {
                setFieldValue('face_image', e.target.files[0]);
                // console.log('uploaded face image')
            }
        }
        reader.readAsDataURL(e.target.files[0]);
    }

    const ImagePreview = ({ image }) => {
        if (loadedImage === null) {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    setLoadedImage(reader.result)
                }
            }
            reader.readAsDataURL(image);
            // console.log('image converted')
        }
        // console.log('rendering preview');

        return (
            <img
                src={loadedImage}
                alt="Imagem de identificação"
                style={{ maxWidth: '100%', maxHeight: '100%' }}
            />
        );
    };

    const saveUser = async (values, formik) => {
        try {
            //return;
            const data = new FormData();
            // console.log({
            //     ...values,
            //     device_id: values.device_id.filter(value => !!value),
            //     selected_users: selectedUsers,
            //     visiting_days: days,
            //     visiting_start: date(validationDate.start_time).format('HH:mm'),
            //     visiting_end: date(validationDate.end_time).format('HH:mm')
            // })
            data.append('face_image', values.face_image);

            values.org_id = selectedOrg.id;
            values.visiting_location = selectedPlace.id;

            const userData = {
                ...values,
                // device_id: deviceIds.device_id,
                visiting_days: days,
                visiting_start: date(validationDate.start_time).format('HH:mm'),
                visiting_end: date(validationDate.end_time).format('HH:mm'),
                dependant_relationships: dependantRelationships,
                credentials: credentialsRef.current.getValues(),
                ...accessRef.current.getValues(),
            };

            userData.face_image = undefined;

            data.append('user_data', JSON.stringify(userData));
            // console.log("user data :|", userData)
          const result = await api.post('/guest/create', data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            const { user } = result.data;
            dispatchValidationDate({ type: 'reset' });
            if (values.constant_visiting) {
                daysRef.current.resetValues();
            }
            setDependantRelationships([]);
            resetForm(formik);
            accessRef.current.resetValues();
            credentialsRef.current.resetValues();
            setSelectedOrg({});
            setSelectedPlace({});

            formik.setSubmitting(false);

            setMessage({
                open: true,
                variant: 'success',
                text: `Visitante ${user.name} cadastrado(a) com sucesso!`,
            });

            setTimeout(() => setOpenGoBack(true), 1500);
        }
        catch (err) {
            // console.log(err)
            setMessage({
                open: true,
                variant: 'error',
                text: err.error,
            });
        }
    };

    const formatUserData = values => {
        if (values.cpf)
            values.cpf = values.cpf.replace(/\D/g, '');

        if (values.rg)
            values.rg = values.rg.replace(/\D/g, '');

        if (values.phone)
            values.phone = values.phone.replace(/\D/g, '');
    };

    const resetForm = formik => {
        formik.resetForm();
    };

    const closeMessage = () => {
        setMessage({
            open: false,
            variant: '',
            text: '',
        });
    };

    const handleConstantVisiting = (setValue, { value: checked }) => {
        // console.log(checked)
        setValue('constant_visiting', checked);
        if (checked) {
            setValue('validation_date', null);
        } else {
            daysRef.current.resetValues();
            setValue('validation_date', date().format());
        }
    }

    const [dependantSearch, setDependantSearch] = useState('');
    const [dependantLimit, setDependantLimit] = useState(10);
    const [dependantPage, setDependantPage] = useState(0);
    const [dependantTotal, setDependantTotal] = useState(0);
    const [dependantResult, setDependantResult] = useState([]);
    const [fetchOnlySelectedDependant, setFetchOnlySelectedDependant] = useState(false);

    const [dependantRelationships, setDependantRelationships] = useState([]);
    const [openDependantModal, setOpenDependantModal] = useState(false);

    const [openRTSP, setOpenRTSP] = useState(false);
    const [rtspRunning, setRTSPRunning] = useState(false);
    const [loadingRSTP, setLoadingRSTP] = useState(false);

    const [selectedWebcam, setSelectedWebcam] = useState(null);
    const [webcamPickerOpen, setWebcamPickerOpen] = useState(false);

    const rtspCanvas = useRef(null);

    const handleOnlySelectedDependant = (checked) => {
        setDependantPage(0);
        setFetchOnlySelectedDependant(checked);
    }

    useEffect(() => {
        const loadUsers = async () => {
            try {
                const result = await api.get('/user/list_by_relationship', {
                    params: {
                        search: dependantSearch,
                        limit: dependantLimit,
                        page: dependantPage,
                        onlySelected: fetchOnlySelectedDependant,
                        selectedPeople: dependantRelationships,
                    },
                });

                const { count, users } = result.data;

                console.log({ users })

                setDependantResult(users);
                setDependantTotal(count);
            }
            catch (err) {
                console.log(err);
            }
        };

        loadUsers();

        //eslint-disable-next-line
    }, [dependantPage, dependantLimit, dependantSearch, fetchOnlySelectedDependant]);

    const [ setOrgsSelect] = useState([]);
    const [orgSearch, ] = useState("");
    const [selectedOrg, setSelectedOrg] = useState({});

    useEffect(() => {
        const findOrg = async () => {
            try {
                const result = await api.get('/organizational_structure/index', {
                    params: {
                        search: orgSearch,
                    }
                });

                const { orgs } = result.data;

                setOrgsSelect(orgs);
            }
            catch (err) {
                console.log(err.message);
            }
        };

        findOrg();
    }, [orgSearch]);

    useEffect(() => {
        if (openRTSP && selectedWebcam) {
            const {host, username, password} = selectedWebcam;

            setTimeout(() => {
                loadPlayer({
                    url: `${config.relayUrl}/api/stream/?nvr=${host}&cam=1&username=${username}&password=${password}&subtype=0`,
                    canvas: rtspCanvas.current,
                    onSourceEstablished: connectionEstabilished,
                    onPlay: playStarted,
                    onDisconnect: () => setRTSPRunning(false),
                });
            }, 2000);
        }
    }, [openRTSP, selectedWebcam]);

    useEffect(() => {
        if (selectedWebcam) {
            setOpenRTSP(true);
        }
        else {
            handleCloseRSTP();
        }
    }, [selectedWebcam]);

    const connectionEstabilished = () => {
        setLoadingRSTP(true);
    };

    const playStarted = () => {
        setRTSPRunning(true);
        setLoadingRSTP(false);
    }

    const handleCloseRSTP = () => {
        setOpenRTSP(false);
        setLoadingRSTP(false);
        setRTSPRunning(false);
        setWebcamPickerOpen(false);
    }

    const changePage = (_, newPage) => {
        setDependantPage(newPage);
    }

    const quantityPerPage = (target) => {
        setDependantLimit(parseInt(target.value, 10));
        setDependantPage(0);
    };

    const checkDependant = (type, isSelected, id) => {
        if (type === "single") {
            let newSelectedUsers = Object.assign([], dependantRelationships);
            if (isSelected) {
                newSelectedUsers.push(id);
            } else {
                let index = dependantRelationships.indexOf(id);
                newSelectedUsers.splice(index, 1);
            }
            setDependantRelationships(newSelectedUsers);
        } else if (type === 'all') {
            let allUsers = [];
            if (isSelected) {
                allUsers = Object.assign([], dependantRelationships);
                dependantResult.forEach(user => {
                    if (!allUsers.includes(user.id)) {
                        allUsers.push(user.id)
                    }
                });
            } else {
                let userIds = dependantResult.map(el => el.id);
                allUsers = dependantRelationships.filter(user => !userIds.includes(user));
            }
            setDependantRelationships(allUsers);
        }
    };

    const [ setCustomInputs] = useState([]);

    useEffect(() => {
        const findInputs = async () => {
            try {
                const result = await api.get('/custom_input/list', {
                    params: {
                        target: ['all', 'guest'],
                        page: 0,
                        limit: 30,
                    }
                });

                const { custom_inputs } = result.data;

                setCustomInputs(custom_inputs);
            }
            catch (err) {
                console.log(err);
            }
        };

        findInputs();
    }, );

    return (
        <div className={classes.root}>
            <SideMenu />
            <main className={classes.content}>
                <Toolbar />
                <Grid container spacing={3}>
                    <Grid container xs={12}>
                        <Typography xs={6} variant="h5" className={classes.title}>
                            Cadastro Simples
                        </Typography>
                    </Grid>
                    <Formik
                        initialValues={initialValues}
                        validate={formatUserData}
                        onSubmit={saveUser}
                    >
                        {({ values, setFieldValue, handleChange, handleSubmit, isSubmitting }) => (
                            <>
                                <Grid item xs={12}>
                                    <Paper alevation={3}>
                                        <form id="guest-create" onSubmit={handleSubmit} className={classes.form}>
                                            <Grid container spacing={3}>
                                                <Grid item xs={3} className={classes.formSection} >
                                                    <div className={classes.faceImageContainer}
                                                        style={{
                                                            height: '300px',
                                                            width: '350px',
                                                        }}
                                                    >
                                                        <div
                                                            className={classes.faceImageContent}
                                                            style={{
                                                                width: '100%',
                                                                height: openRTSP ? "600px" : "200px",
                                                            }}
                                                        >
                                                            {!!openRTSP ? (
                                                                <div style={{
                                                                    backgroundmaxHeight: '100%',
                                                                    height: '100%',
                                                                    maxWidth: '100%',
                                                                    margin: 'auto',
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                }}>
                                                                    <canvas ref={rtspCanvas} style={{ width: '100%', height: '100%', borderRadius: '8px', objectFit: 'contain' }}></canvas>
                                                                </div>
                                                            ) : !cameraOpened ? (
                                                                values.face_image ? (
                                                                    <ImagePreview image={values.face_image} />
                                                                ) : (
                                                                    <div className={classes.noImage}>
                                                                        <PhotoCameraIcon />
                                                                        <Typography variant="subtitle2">
                                                                            SEM IMAGEM
                                                                        </Typography>
                                                                    </div>
                                                                )
                                                            ) : (
                                                                <Webcam
                                                                    ref={webcamRef}
                                                                    audio={false}
                                                                    screenshotFormat="image/jpeg"
                                                                    screenshotQuality={1}
                                                                    forceScreenshotSourceSize={true}
                                                                    // width="100%"
                                                                    height="100%"
                                                                />
                                                            )}
                                                        </div>
                                                        {values.face_image && (
                                                            <Button
                                                                className={classes.removeImageButton}
                                                                size="small"
                                                                type="button"
                                                                variant="outlined"
                                                                color="secondary"
                                                                endIcon={<DeleteIcon />}
                                                                fullWidth
                                                                onClick={() => {
                                                                    setFieldValue('face_image', null);
                                                                    setLoadedImage(null);
                                                                }}
                                                            >
                                                                Remover
                                                            </Button>
                                                        )}
                                                        {
                                                            !values.face_image && (
                                                                <>
                                                                    <Button
                                                                        className={cameraOpened ? classes.faceImageButton : classes.faceImageButtonDefault}
                                                                        type="button"
                                                                        variant="outlined"
                                                                        color="primary"
                                                                        endIcon={<PhotoCameraIcon />}
                                                                        fullWidth
                                                                        onClick={async () => {
                                                                            if (cameraOpened) await captureImage(setFieldValue);

                                                                            setCameraOpened(!cameraOpened);
                                                                        }}
                                                                    >
                                                                        {cameraOpened ? 'Tirar foto' : 'Abrir câmera'}
                                                                    </Button>
                                                                    {
                                                                        !cameraOpened && (
                                                                            <>
                                                                                <Button
                                                                                    className={classes.faceImageButtonDefault}
                                                                                    variant="outlined"
                                                                                    type="button"
                                                                                    color="primary"
                                                                                    fullWidth={true}
                                                                                    onClick={() => setWebcamPickerOpen(true)}
                                                                                    endIcon={<VideocamIcon />}
                                                                                >
                                                                                    Selecionar Webcam
                                                                                </Button>
                                                                                <Button
                                                                                    className={classes.faceImageButton}
                                                                                    type="button"
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    endIcon={<UploadIcon />}
                                                                                    fullWidth
                                                                                    component="label"
                                                                                >
                                                                                    Adicionar Foto
                                                                                    <input
                                                                                        name='map_image'
                                                                                        type="file"
                                                                                        accept="image/*"
                                                                                        onChange={(e) => uploadImage(e, setFieldValue)}
                                                                                        hidden
                                                                                        required={false}
                                                                                    />
                                                                                </Button>
                                                                            </>
                                                                        )
                                                                    }
                                                                </>
                                                            )
                                                        }
                                                    </div>
                                                </Grid>
                                          

                                            <Grid container spacing={3}>
                                            <Grid item xs={12}  className={classes.formSection}>
                                                <Typography variant="subtitle1" className={classes.formSectionTitle}>
                                                DADOS PESSOAIS
                                                </Typography>
                                                <Grid container spacing={3}>
                                                <Grid item xs={12} sm={6} md={3}>
                                                    <Input
                                                    label="Nome completo"
                                                    textFieldProps={{
                                                        name: 'name',
                                                        placeholder: 'Nome completo',
                                                        onChange: handleChange,
                                                        value: values.name,
                                                        fullWidth: true,
                                                        required: true,
                                                    }}
                                                    />
                                                </Grid>
                                                
                                                <Grid item xs={12} sm={6} md={3}>
                                                    <Select
                                                    label="Tipo de Documento"
                                                    options={[
                                                        { label: '-- Selecione --', value: '' },
                                                        { label: 'CPF', value: 'unknown' },
                                                        { label: 'RG', value: 'ic' },
                                                        { label: 'Passaporte', value: 'passport' },
                                                        { label: 'Outro', value: 'other' },
                                                    ]}
                                                    textFieldProps={{
                                                        name: 'doc_type',
                                                        onChange: handleChange,
                                                        fullWidth: true,
                                                        value: values.doc_type,
                                                        required: values.doc_number !== null && values.doc_number !== '',
                                                    }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={3}>
                                                    <Input
                                                    label="Número do Documento"
                                                    textFieldProps={{
                                                        name: 'doc_number',
                                                        placeholder: 'Número do Documento',
                                                        onChange: handleChange,
                                                        value: values.doc_number,
                                                        fullWidth: true,
                                                        required: values.doc_type !== null && values.doc_type !== '',
                                                    }}
                                                    />
                                                </Grid>
                                                </Grid>
                                            </Grid>
                                            </Grid>

                                            </Grid>
                                            <Grid container className={classes.formSection}>
                                                <Typography variant="subtitle1" className={classes.formSectionTitle}>
                                                    VALIDADE DO ACESSO
                                                </Typography>
                                                <Grid container spacing={2}>
                                                    {
                                                        !values.constant_visiting && (
                                                            <Grid item xs={6}>
                                                                <DatePicker
                                                                    label="Dia da Visita"
                                                                    format="DD/MM/YYYY"
                                                                    id="date"
                                                                    value={values.validation_date}
                                                                    placeholder="Dia da visita"
                                                                    onChange={date => setFieldValue('validation_date', date && date.format())}
                                                                    cancelLabel="cancelar"
                                                                    fullWidth={true}
                                                                    required={!values.constant_visiting}
                                                                />
                                                            </Grid>
                                                        )
                                                    }

                                                    
                                                     <Grid item xs={12} sm={6} md={2}>
                                                        <Select
                                                            label="Visita Frequente"
                                                            options={[
                                                                {
                                                                    label: "Sim",
                                                                    value: true,
                                                                },
                                                                {
                                                                    label: "Não",
                                                                    value: false,
                                                                },
                                                            ]}
                                                            textFieldProps={{
                                                                name: "constant_visiting",
                                                                value: values.constant_visiting,
                                                                onChange:
                                                                    ({ target }) => handleConstantVisiting(setFieldValue, target),
                                                                fullWidth: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <Grid container className={classes.formSection}
                                                style={{ display: (values.constant_visiting ? 'flex' : 'none') }}
                                            >
                                                <Typography variant="subtitle1" className={classes.formSectionTitle}>
                                                    DIAS DE ACESSO
                                                </Typography>
                                                <Grid container spacing={2}>
                                                    <DaysPicker setDays={setDays} ref={daysRef} />
                                                </Grid>
                                            </Grid>
                
                                            <Grid container className={classes.formSection}>
                                                <Typography
                                                    variant="subtitle1"
                                                    className={classes.formSectionTitle}
                                                    onClick={() => console.log(accessRef.current.getValues())}
                                                >
                                                    AUTORIZAÇÃO
                                                </Typography>
                                                <AccessPicker ref={accessRef} />
                                            </Grid>
                                            <Grid item xs={12} container justify="flex-end">
                                                <Button
                                                    disabled={isSubmitting}
                                                    type="submit"
                                                    variant="contained"
                                                    form="guest-create"
                                                    color="primary"
                                                    endIcon={<SaveIcon />}
                                                >
                                                    {isSubmitting ? 'Salvando...' : 'Salvar dados'}
                                                </Button>
                                            </Grid>
                                        </form>
                                    </Paper>
                                </Grid>
                                <FullScreenDialog
                                    open={openRTSP}
                                    title={`${selectedWebcam?.name} - ${loadingRSTP ? 'CARREGANDO' : (rtspRunning ? 'CONECTADO' : 'DESCONECTADO')}`}
                                    onClose={handleCloseRSTP}
                                >
                                    <Grid
                                        xs={12}
                                        style={{display: 'flex', marginBottom: 20}}
                                        justify="center"
                                        alignItems="center"
                                    >
                                        <canvas ref={rtspCanvas} style={{ height: '100%', width: '60%', borderRadius: '8px', objectFit: 'contain' }}></canvas>
                                    </Grid>
                                    {(!loadingRSTP && rtspRunning) && (
                                        <Grid item xs={12} style={{textAlign: 'center'}}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={async () => takeWebcamSnapshot(setFieldValue)}
                                                endIcon={<PhotoCameraIcon />}
                                            >
                                                Tirar foto
                                            </Button>
                                        </Grid>
                                    )}
                                </FullScreenDialog>
                            </>
                        )}
                    </Formik>
                </Grid>
                {!!message.open && (
                    <Alert
                        open={message.open}
                        autoHideDuration={6000}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        severity={message.variant}
                        onClose={closeMessage}
                    >
                        {message.text}
                    </Alert>
                )}
            </main>
            <IPWebcamPicker
                open={webcamPickerOpen}
                onSelect={webcam => setSelectedWebcam(webcam)}
                onClose={() => setWebcamPickerOpen(false)}
            />
            <Popup
                openPopup={openDependantModal}
                setOpenPopup={setOpenDependantModal}
                title="Adcione pessoas das quais a atual depende"
            >
                <Grid container spacing={3}>
                    <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                        <Grid item xs={4}>
                            <Input
                                icon={<SearchIcon style={{ color: grey[400] }} />}
                                iconPosition="start"
                                textFieldProps={{
                                    placeholder: 'Buscar…',
                                    onChange: ({ target }) => setDependantSearch(target.value),
                                    values: dependantSearch,
                                    fullWidth: true,
                                }}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <FormControlLabel
                                label="Mostrar apenas selecionados"
                                style={{
                                    userSelect: "none",
                                }}
                                checked={fetchOnlySelectedDependant}
                                onChange={({ target: { checked } }) => handleOnlySelectedDependant(checked)}
                                control={
                                    <Checkbox
                                        color='primary'

                                    />
                                }
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="users list">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={classes.tableHead}>ID</TableCell>
                                        <TableCell className={classes.tableHead}>Nome</TableCell>
                                        <TableCell className={classes.tableHead}>Tipo de Documento</TableCell>
                                        <TableCell className={classes.tableHead}>Nº do Documento</TableCell>
                                        <TableCell className={classes.tableHead}>Tipo de Pessoa</TableCell>
                                         <TableCell className={classes.tableHead}>
                                            <Checkbox
                                                name="addAllUsers"
                                                color="primary"
                                                // checked={selectedUsers.length === users.length}
                                                checked={dependantResult.every(el => {
                                                    return dependantRelationships.includes(el.id);
                                                })}
                                                onChange={({ target }) => checkDependant('all', target.checked)}
                                            />
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {!!dependantResult && dependantResult.map(person => (
                                        <TableRow key={person.id}>
                                            <TableCell className={classes.tableBody} component="th" scope="row">
                                                {person.id}
                                            </TableCell>
                                            <TableCell className={classes.tableBody}>
                                                <RedirectToUser pType={person.person_type_id} uId={person.id}>
                                                    {person.name}
                                                </RedirectToUser>
                                            </TableCell>
                                            <TableCell className={classes.tableBody}>
                                                {person.doc_type && person?.doc_type === 'ic' ? 'RG' :
                                                    person?.doc_type === 'passport' ? 'Passaporte' :
                                                        person?.doc_type === 'other' ? 'Outro' :
                                                            person?.doc_type === 'unknown' ? 'CPF' :
                                                                'Não identificado'}
                                            </TableCell>
                                            <TableCell className={classes.tableBody}>
                                                {person.doc_number ? person.doc_number : "Não identificado"}
                                            </TableCell>
                                            <TableCell className={classes.tableBody}>
                                                {person.PersonType?.name ? person.PersonType?.name : "Não identificado"}
                                            </TableCell>
                                            <TableCell className={classes.tableBody}>
                                                <Checkbox
                                                    name="addUser"
                                                    color="primary"
                                                    checked={dependantRelationships.includes(person.id)}
                                                    onChange={({ target }) => checkDependant('single', target.checked, person.id)}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10, 20, 30]}
                            component="div"
                            count={dependantTotal}
                            rowsPerPage={dependantLimit}
                            page={dependantPage}
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            labelRowsPerPage="Registros por página"
                            onChangePage={(_, newPage) => changePage(_, newPage)}
                            onChangeRowsPerPage={({ target }) => quantityPerPage(target)}
                        />
                    </Grid>
                </Grid>
            </Popup>
            <Popup
                openPopup={openGoBack}
                setOpenPopup={setOpenGoBack}
                title="Voltar a listagem de pessoas?"
                width="30%"
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 6,
                    }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ width: "40%", fontWeight: 700 }}
                        size="large"
                        onClick={() => history.push("/pessoa")}
                    >
                        SIM
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        style={{ width: "40%", fontWeight: 700 }}
                        size="large"
                        onClick={() => setOpenGoBack(false)}
                    >
                        NÃO
                    </Button>
                </div>
            </Popup>
        </div >
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        marginTop: theme.spacing(5),
    },
    title: {
        color: grey[700],
        fontSize: 28,
    },
    form: {
        padding: theme.spacing(3, 3),
    },
    formSection: {
        marginBottom: theme.spacing(3),
    },
    formSectionTitle: {
        fontWeight: 'bold',
        color: grey[700],
        marginBottom: theme.spacing(1),
    },
    faceImageContainer: {
        width: '100%',
        height: '303px',
        border: `solid 1px ${indigo[200]}`,
        borderRadius: 5,
        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'column',
    },
    faceImageContent: {
        width: '100%',
        flex: 7,
        backgroundColor: grey[50],
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(.5),
    },
    faceImageButton: {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        flex: 1,
    },
    faceImageButtonDefault: {
        borderRadius: 0,
        flex: 1,
    },
    removeImageButton: {
        borderRadius: 0,
        // marginBottom: theme.spacing(1),
    },
    noImage: {
        textAlign: 'center',
        color: grey[400],
    },
    cameraContainer: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        '& h6 > span': {
            marginLeft: theme.spacing(.5),
        },
        '&:hover': {
            boxShadow: '0 2px 10px 1px rgba(150,150,150,.3)',
        },
    },
    tableContainer: {
        maxHeight: '95%',
        width: '100%',
    },
    table: {
        width: '100%',
    },
    tableHead: {
        textAlign: 'center',
        textTransform: 'uppercase',
        color: grey[500],
    },
    tableBody: {
        color: grey[800],
        textAlign: 'center',
    },
}));

const PhoneMask = props => {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={ref => inputRef(ref ? ref.inputElement : null)}
            mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
            placeholderChar={'_'}
            showMask
        />
    );
};
